var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#01D9C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3947 7.10872L8.98332 11.4234L7.04761 9.35852C6.7218 9.01096 6.19517 9.01096 5.86936 9.35852C5.54355 9.70608 5.54355 10.2679 5.86936 10.6154L8.36919 13.2821C8.53085 13.4546 8.745 13.5417 8.95832 13.5417C9.15998 13.5417 9.36163 13.4643 9.52162 13.3079L14.5213 8.41895C14.8604 8.08739 14.8838 7.52472 14.573 7.16294C14.2621 6.80116 13.7347 6.77716 13.3947 7.10872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckball);
export default __webpack_public_path__ + "static/media/green-checkball.6f43d4e8.svg";
export { ForwardRef as ReactComponent };